export const MOBILE_VIEW = 'mobile'
export const DESKTOP_VIEW = 'desktop'

export function isMobile(view: string): boolean {
  return view === MOBILE_VIEW
}
